import { SagaDate, SagaDatePipe } from '@app/pipes/saga-date/saga-date.pipe';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { TranslateService } from '@ngx-translate/core';
import { ICallcardFormatter } from '../../../schema/interfaces/callcard-formatter';

export class DefaultCallcardFormatter implements ICallcardFormatter {
  constructor(private translate: TranslateService, private sagaDate: SagaDatePipe) {}

  format(callcard: CallCard) {
    callcard.name = `${this.translate.instant('Mobile.CardNumberTitle')}${callcard.Id}`;

    callcard.rLong = [
      [
        `${this.translate.instant('Mobile.CardNumberTitle')}${callcard.Id}`,
        this.sagaDate.transform(callcard.CreatedUTC, SagaDate.SUBMITTED)
      ]
        .filter(text => text)
        .join(' - '),
      [`${this.translate.instant(callcard.status.Name)}`].filter(text => text).join('')
    ];
  }
}
